import {
  AUTH_SIGNOUT,
  AUTH_SUCCESS,
  GET_SECURITY_QUESTIONS,
  MICROSOFT_LOGIN,
  NEW_USER_REGISTRATION_RESPONSE,
  SUBMIT_SECURITY_QUESTIONS
} from '../constants/actionTypes';

export const initialState = {
  authenticated: false,
  firstTimeLogin: false,
  securityQuestions: []
};

const auth = (state = initialState, { type, payload }) => {
  switch (type) {
    case AUTH_SUCCESS:
    case SUBMIT_SECURITY_QUESTIONS:
      return { ...state, authenticated: true };

    case NEW_USER_REGISTRATION_RESPONSE:
      return { ...state, authenticated: true, firstTimeLogin: payload };

    case AUTH_SIGNOUT:
      return { ...state, authenticated: false };

    case MICROSOFT_LOGIN:
      return { ...state, authenticated: true };

    case GET_SECURITY_QUESTIONS:
      return { ...state, securityQuestions: payload };

    default:
      return {
        ...state
      };
  }
};

export default auth;
